module.exports = __webpack_public_path__ + "static/media/cardSix.b9de8393.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowTwo/cardSix.jpg
// module id = 19
// module chunks = 0